import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import globals from '../globals'

const MobilePlanAdditionalData = (props) => {
    return (
        <div>
            {props.content[0] && props.content[1] ? <Content title={props.content[0]} description={props.content[1]} /> : ''}
            {props.content[2] && props.content[3] ? <div className='mt-3'><Content title={props.content[2]} description={props.content[3]} /></div> : ''}
        </div>
    )
}

MobilePlanAdditionalData.propTypes = {
    content: PropTypes.array.isRequired
}

export default MobilePlanAdditionalData

const Content = (props) => {
    const subRef = useRef(null)
    const expandRef = useRef(null)

    const handleExpand = event => {
        event.preventDefault()
        subRef.current.style.display = 'none'
        expandRef.current.style.display = 'block'
    }

    return (
        <React.Fragment>
            <p className='m-0 mb-1 font-small bold' dangerouslySetInnerHTML={{ __html: globals.noWidows(props.title) }} />
            <div className='font-xsmall'>
                <div>
                    {props.description}
                </div>
                {/* <div ref={subRef}> */}
                {/*    {props.description.substring(0, 20)}... <a href="#" onClick={handleExpand}>more</a> */}
                {/* </div> */}
                {/* <div ref={expandRef} style={{display: 'none'}}> */}
                {/*    {props.description} */}
                {/* </div> */}
            </div>
        </React.Fragment>
    )
}



// WEBPACK FOOTER //
// ./resources/js/components/MobilePlanAdditionalData.js